import React, { Component } from "react";

import "./style.css";

class Footer extends Component {
  componentDidMount() { }

  render() {
    return (
      <footer id="footer">
        <p className="copyright">
          &copy; LWO
        </p>
      </footer>
    );
  }
}

export default Footer;
